// extracted by mini-css-extract-plugin
export var content = "CheckoutRoute-module__content___Qi1A8";